export const getWhiteLabelReferral = (partner, isPackageSearch) => {
  let whiteLabelProduct = isPackageSearch ? partner?.products?.package : partner?.products?.flight

  if (!whiteLabelProduct) {
    whiteLabelProduct = partner
  }

  return whiteLabelProduct?.refId
    ? {
        clickId: '',
        id: whiteLabelProduct.refId.substring(2),
        rID: whiteLabelProduct.refId,
        sourceId: whiteLabelProduct.refId.slice(0, 2),
      }
    : null
}

export const getWhiteLabelPlf = (partner, isPackageSearch) => {
  const whiteLabelProduct = isPackageSearch ? partner?.products?.package : partner?.products?.flight

  return whiteLabelProduct?.plfCode || partner?.plfCode
}
